<template>
  <div class="navbar">
    <!-- 顶部菜单 -->
    <div class="right-menu">
      <!-- 全屏 -->
      <span class="svg-container" @click="fullScreen()">
        <svg-icon icon-class="zoom-in" />
      </span>
      <!-- ai -->
      <!-- <span class="svg-container" @click="openAI()">
        <img src="@/assets/icon/AI.png" alt="" srcset="" style="width: 20px;">
      </span> -->
      <!-- 首页 -->
      <span class="svg-container" @click="home()">
        <svg-icon icon-class="index" />
      </span>
      <!-- 看板中心
      <span class="svg-container" @click="toggleSideBar()">
        <svg-icon icon-class="report" />
      </span>
       -->
      <!-- 看板中心
      <span class="svg-container">
        <svg-icon icon-class="dashboard" />
      </span>
       -->
      <!-- 用户信息
      <span class="svg-container">
        <svg-icon icon-class="user" @click="userInfo()" />
      </span>
       -->
      <!-- 退出 -->
      <span class="svg-container " @click="logout()">
        <svg-icon icon-class="logout" />
      </span>
    </div>
    <ai-dialog
      :visible.sync="dialogVisible"
      :dialog-id="dialogId"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import aiDialog from './aiDialog.vue'
export default {
  components: {
    aiDialog
  },
  data() {
    return {
      isFullScreen: false,
      dialogId: '',
      dialogVisible: false
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  methods: {
    // 图标1 - 全屏
    fullScreen() {
      if (!this.isFullScreen) {
        // documentElement 属性以一个元素对象返回一个文档的文档元素
        const el = document.documentElement
        el.requestFullscreen || el.mozRequestFullScreen || el.webkitRequestFullscreen || el.msRequestFullScreen
          ? el.requestFullscreen() || el.mozRequestFullScreen() || el.webkitRequestFullscreen() || el.msRequestFullscreen() : null
        this.isFullScreen = true
      } else {
        if (document.exitFullScreen) {
          document.exitFullScreen()
          this.isFullScreen = false
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
          this.isFullScreen = false
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
          this.isFullScreen = false
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
          this.isFullScreen = false
        }
      }
    },
    // 主页
    home() {
      this.$router.push({
        path: '/base/home'
      })
    },
    // 个人信息
    userInfo() {
      const user = {
        name: "个人信息",
        url: "/base/user"
      }
      this.$store.dispatch('tagsView/addView', user)
      this.$router.push({
        path: '/base/user'
      })
    },
    // 左侧菜单
    toggleSideBar() {
      // 设置左侧菜单隐藏
      this.$store.dispatch('app/toggleSideBar')
    },
    // 退出
    logout() {
      const $this = this
      // 清楚缓存
      this.$store.dispatch('clear')
      localStorage.removeItem('user')
      // 跳转
      $this.$router.push(`/dc/admin/login`)
      this.loading = false
    },
    // ai弹窗
    openAI() {
      this.dialogVisible = true
      this.dialogId = this.$store.state.user.userCode + Date.now()
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  // background-color: #5697F1;
  // background-color: #1482f0;
  color: #ffffff;
  overflow: hidden;
  position: relative;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .right-menu {
    // display:inline-block;
    display: flex;
    justify-content: space-around;
    align-items: center;
    // float: right;
    position: absolute;
    right: 0;
    height: 100%;
    line-height: 50px;

    .svg-container {
      font-size: 24px;
      margin-left: 20px;
      margin-right: 20px;
      color: #000000;
      cursor: pointer;
    }
    .svg-container :hover {
      color: #409EFF;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

}
</style>
